import React from 'react';

const BASENAME = process.env.PUBLIC_URL;

const ActivationCellRenderer = ({value, data}) => {
    const {has_licenses_permission, ibge} = data;

    const openLicense = () => {
        if (has_licenses_permission) {
            window.open(`${BASENAME}/licenses/${ibge}`, ibge);
        }
    }

    return (
        <div className={has_licenses_permission ? "text-blue-700 w-full hover:underline" : ""} onClick={openLicense}>
            {value}
        </div>
    );
};

export default ActivationCellRenderer;